/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppActsRouteImport } from './routes/_app/acts'
import { Route as AppAnalyticsRouteImport } from './routes/_app/analytics'
import { Route as AppCalendarRouteImport } from './routes/_app/calendar'
import { Route as AppContractsRouteImport } from './routes/_app/contracts'
import { Route as AppDocumentsRouteImport } from './routes/_app/documents'
import { Route as AppDuplicatesRouteImport } from './routes/_app/duplicates'
import { Route as AppMailRouteImport } from './routes/_app/mail'
import { Route as AppPayrollRouteImport } from './routes/_app/payroll'
import { Route as AppReferenceRouteImport } from './routes/_app/reference'
import { Route as AppRemindersRouteImport } from './routes/_app/reminders'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppStaffingRouteImport } from './routes/_app/staffing'
import { Route as AppTimesheetsRouteImport } from './routes/_app/timesheets'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AppCandidatesIndexRouteImport } from './routes/_app/candidates/index'
import { Route as AppContestsIndexRouteImport } from './routes/_app/contests/index'
import { Route as AppContestsContestIdRouteImport } from './routes/_app/contests/$contestId'
import { Route as AppEmployeesIndexRouteImport } from './routes/_app/employees/index'
import { Route as AppEmployeesEmployeeIdRouteImport } from './routes/_app/employees/$employeeId'
import { Route as AppMeIndexRouteImport } from './routes/_app/me/index'
import { Route as AppMeReportsRouteImport } from './routes/_app/me/reports'
import { Route as AppMeTimesheetRouteImport } from './routes/_app/me/timesheet'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProjectsProjectIdRouteImport } from './routes/_app/projects/$projectId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppActsRoute = AppActsRouteImport.update({
  id: '/acts',
  path: '/acts',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppContractsRoute = AppContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsRoute = AppDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppRoute,
} as any)
const AppDuplicatesRoute = AppDuplicatesRouteImport.update({
  id: '/duplicates',
  path: '/duplicates',
  getParentRoute: () => AppRoute,
} as any)
const AppMailRoute = AppMailRouteImport.update({
  id: '/mail',
  path: '/mail',
  getParentRoute: () => AppRoute,
} as any)
const AppPayrollRoute = AppPayrollRouteImport.update({
  id: '/payroll',
  path: '/payroll',
  getParentRoute: () => AppRoute,
} as any)
const AppReferenceRoute = AppReferenceRouteImport.update({
  id: '/reference',
  path: '/reference',
  getParentRoute: () => AppRoute,
} as any)
const AppRemindersRoute = AppRemindersRouteImport.update({
  id: '/reminders',
  path: '/reminders',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppStaffingRoute = AppStaffingRouteImport.update({
  id: '/staffing',
  path: '/staffing',
  getParentRoute: () => AppRoute,
} as any)
const AppTimesheetsRoute = AppTimesheetsRouteImport.update({
  id: '/timesheets',
  path: '/timesheets',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCandidatesIndexRoute = AppCandidatesIndexRouteImport.update({
  id: '/candidates/',
  path: '/candidates/',
  getParentRoute: () => AppRoute,
} as any)
const AppContestsIndexRoute = AppContestsIndexRouteImport.update({
  id: '/contests/',
  path: '/contests/',
  getParentRoute: () => AppRoute,
} as any)
const AppContestsContestIdRoute = AppContestsContestIdRouteImport.update({
  id: '/contests/$contestId',
  path: '/contests/$contestId',
  getParentRoute: () => AppRoute,
} as any)
const AppEmployeesIndexRoute = AppEmployeesIndexRouteImport.update({
  id: '/employees/',
  path: '/employees/',
  getParentRoute: () => AppRoute,
} as any)
const AppEmployeesEmployeeIdRoute = AppEmployeesEmployeeIdRouteImport.update({
  id: '/employees/$employeeId',
  path: '/employees/$employeeId',
  getParentRoute: () => AppRoute,
} as any)
const AppMeIndexRoute = AppMeIndexRouteImport.update({
  id: '/me/',
  path: '/me/',
  getParentRoute: () => AppRoute,
} as any)
const AppMeReportsRoute = AppMeReportsRouteImport.update({
  id: '/me/reports',
  path: '/me/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppMeTimesheetRoute = AppMeTimesheetRouteImport.update({
  id: '/me/timesheet',
  path: '/me/timesheet',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/acts': typeof AppActsRoute
  '/analytics': typeof AppAnalyticsRoute
  '/calendar': typeof AppCalendarRoute
  '/contracts': typeof AppContractsRoute
  '/documents': typeof AppDocumentsRoute
  '/duplicates': typeof AppDuplicatesRoute
  '/mail': typeof AppMailRoute
  '/payroll': typeof AppPayrollRoute
  '/reference': typeof AppReferenceRoute
  '/reminders': typeof AppRemindersRoute
  '/reports': typeof AppReportsRoute
  '/staffing': typeof AppStaffingRoute
  '/timesheets': typeof AppTimesheetsRoute
  '/users': typeof AppUsersRoute
  '/invite/$token': typeof InviteTokenRoute
  '/contests/$contestId': typeof AppContestsContestIdRoute
  '/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/me/reports': typeof AppMeReportsRoute
  '/me/timesheet': typeof AppMeTimesheetRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/candidates/': typeof AppCandidatesIndexRoute
  '/contests/': typeof AppContestsIndexRoute
  '/employees/': typeof AppEmployeesIndexRoute
  '/me/': typeof AppMeIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/acts': typeof AppActsRoute
  '/analytics': typeof AppAnalyticsRoute
  '/calendar': typeof AppCalendarRoute
  '/contracts': typeof AppContractsRoute
  '/documents': typeof AppDocumentsRoute
  '/duplicates': typeof AppDuplicatesRoute
  '/mail': typeof AppMailRoute
  '/payroll': typeof AppPayrollRoute
  '/reference': typeof AppReferenceRoute
  '/reminders': typeof AppRemindersRoute
  '/reports': typeof AppReportsRoute
  '/staffing': typeof AppStaffingRoute
  '/timesheets': typeof AppTimesheetsRoute
  '/users': typeof AppUsersRoute
  '/invite/$token': typeof InviteTokenRoute
  '/': typeof AppIndexRoute
  '/contests/$contestId': typeof AppContestsContestIdRoute
  '/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/me/reports': typeof AppMeReportsRoute
  '/me/timesheet': typeof AppMeTimesheetRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/candidates': typeof AppCandidatesIndexRoute
  '/contests': typeof AppContestsIndexRoute
  '/employees': typeof AppEmployeesIndexRoute
  '/me': typeof AppMeIndexRoute
  '/projects': typeof AppProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/acts': typeof AppActsRoute
  '/_app/analytics': typeof AppAnalyticsRoute
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/contracts': typeof AppContractsRoute
  '/_app/documents': typeof AppDocumentsRoute
  '/_app/duplicates': typeof AppDuplicatesRoute
  '/_app/mail': typeof AppMailRoute
  '/_app/payroll': typeof AppPayrollRoute
  '/_app/reference': typeof AppReferenceRoute
  '/_app/reminders': typeof AppRemindersRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/staffing': typeof AppStaffingRoute
  '/_app/timesheets': typeof AppTimesheetsRoute
  '/_app/users': typeof AppUsersRoute
  '/invite/$token': typeof InviteTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/contests/$contestId': typeof AppContestsContestIdRoute
  '/_app/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/_app/me/reports': typeof AppMeReportsRoute
  '/_app/me/timesheet': typeof AppMeTimesheetRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/_app/candidates/': typeof AppCandidatesIndexRoute
  '/_app/contests/': typeof AppContestsIndexRoute
  '/_app/employees/': typeof AppEmployeesIndexRoute
  '/_app/me/': typeof AppMeIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/acts'
    | '/analytics'
    | '/calendar'
    | '/contracts'
    | '/documents'
    | '/duplicates'
    | '/mail'
    | '/payroll'
    | '/reference'
    | '/reminders'
    | '/reports'
    | '/staffing'
    | '/timesheets'
    | '/users'
    | '/invite/$token'
    | '/contests/$contestId'
    | '/employees/$employeeId'
    | '/me/reports'
    | '/me/timesheet'
    | '/projects/$projectId'
    | '/candidates/'
    | '/contests/'
    | '/employees/'
    | '/me/'
    | '/projects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/acts'
    | '/analytics'
    | '/calendar'
    | '/contracts'
    | '/documents'
    | '/duplicates'
    | '/mail'
    | '/payroll'
    | '/reference'
    | '/reminders'
    | '/reports'
    | '/staffing'
    | '/timesheets'
    | '/users'
    | '/invite/$token'
    | '/'
    | '/contests/$contestId'
    | '/employees/$employeeId'
    | '/me/reports'
    | '/me/timesheet'
    | '/projects/$projectId'
    | '/candidates'
    | '/contests'
    | '/employees'
    | '/me'
    | '/projects'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/acts'
    | '/_app/analytics'
    | '/_app/calendar'
    | '/_app/contracts'
    | '/_app/documents'
    | '/_app/duplicates'
    | '/_app/mail'
    | '/_app/payroll'
    | '/_app/reference'
    | '/_app/reminders'
    | '/_app/reports'
    | '/_app/staffing'
    | '/_app/timesheets'
    | '/_app/users'
    | '/invite/$token'
    | '/_app/'
    | '/_app/contests/$contestId'
    | '/_app/employees/$employeeId'
    | '/_app/me/reports'
    | '/_app/me/timesheet'
    | '/_app/projects/$projectId'
    | '/_app/candidates/'
    | '/_app/contests/'
    | '/_app/employees/'
    | '/_app/me/'
    | '/_app/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/acts': {
      id: '/_app/acts'
      path: '/acts'
      fullPath: '/acts'
      preLoaderRoute: typeof AppActsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analytics': {
      id: '/_app/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contracts': {
      id: '/_app/contracts'
      path: '/contracts'
      fullPath: '/contracts'
      preLoaderRoute: typeof AppContractsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents': {
      id: '/_app/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AppDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/duplicates': {
      id: '/_app/duplicates'
      path: '/duplicates'
      fullPath: '/duplicates'
      preLoaderRoute: typeof AppDuplicatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mail': {
      id: '/_app/mail'
      path: '/mail'
      fullPath: '/mail'
      preLoaderRoute: typeof AppMailRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payroll': {
      id: '/_app/payroll'
      path: '/payroll'
      fullPath: '/payroll'
      preLoaderRoute: typeof AppPayrollRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reference': {
      id: '/_app/reference'
      path: '/reference'
      fullPath: '/reference'
      preLoaderRoute: typeof AppReferenceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reminders': {
      id: '/_app/reminders'
      path: '/reminders'
      fullPath: '/reminders'
      preLoaderRoute: typeof AppRemindersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staffing': {
      id: '/_app/staffing'
      path: '/staffing'
      fullPath: '/staffing'
      preLoaderRoute: typeof AppStaffingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/timesheets': {
      id: '/_app/timesheets'
      path: '/timesheets'
      fullPath: '/timesheets'
      preLoaderRoute: typeof AppTimesheetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/candidates/': {
      id: '/_app/candidates/'
      path: '/candidates'
      fullPath: '/candidates/'
      preLoaderRoute: typeof AppCandidatesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contests/': {
      id: '/_app/contests/'
      path: '/contests'
      fullPath: '/contests/'
      preLoaderRoute: typeof AppContestsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contests/$contestId': {
      id: '/_app/contests/$contestId'
      path: '/contests/$contestId'
      fullPath: '/contests/$contestId'
      preLoaderRoute: typeof AppContestsContestIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/employees/': {
      id: '/_app/employees/'
      path: '/employees'
      fullPath: '/employees/'
      preLoaderRoute: typeof AppEmployeesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/employees/$employeeId': {
      id: '/_app/employees/$employeeId'
      path: '/employees/$employeeId'
      fullPath: '/employees/$employeeId'
      preLoaderRoute: typeof AppEmployeesEmployeeIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/': {
      id: '/_app/me/'
      path: '/me'
      fullPath: '/me/'
      preLoaderRoute: typeof AppMeIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/reports': {
      id: '/_app/me/reports'
      path: '/me/reports'
      fullPath: '/me/reports'
      preLoaderRoute: typeof AppMeReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/timesheet': {
      id: '/_app/me/timesheet'
      path: '/me/timesheet'
      fullPath: '/me/timesheet'
      preLoaderRoute: typeof AppMeTimesheetRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppActsRoute: typeof AppActsRoute
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppCalendarRoute: typeof AppCalendarRoute
  AppContractsRoute: typeof AppContractsRoute
  AppDocumentsRoute: typeof AppDocumentsRoute
  AppDuplicatesRoute: typeof AppDuplicatesRoute
  AppMailRoute: typeof AppMailRoute
  AppPayrollRoute: typeof AppPayrollRoute
  AppReferenceRoute: typeof AppReferenceRoute
  AppRemindersRoute: typeof AppRemindersRoute
  AppReportsRoute: typeof AppReportsRoute
  AppStaffingRoute: typeof AppStaffingRoute
  AppTimesheetsRoute: typeof AppTimesheetsRoute
  AppUsersRoute: typeof AppUsersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppContestsContestIdRoute: typeof AppContestsContestIdRoute
  AppEmployeesEmployeeIdRoute: typeof AppEmployeesEmployeeIdRoute
  AppMeReportsRoute: typeof AppMeReportsRoute
  AppMeTimesheetRoute: typeof AppMeTimesheetRoute
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRoute
  AppCandidatesIndexRoute: typeof AppCandidatesIndexRoute
  AppContestsIndexRoute: typeof AppContestsIndexRoute
  AppEmployeesIndexRoute: typeof AppEmployeesIndexRoute
  AppMeIndexRoute: typeof AppMeIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppActsRoute: AppActsRoute,
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppCalendarRoute: AppCalendarRoute,
  AppContractsRoute: AppContractsRoute,
  AppDocumentsRoute: AppDocumentsRoute,
  AppDuplicatesRoute: AppDuplicatesRoute,
  AppMailRoute: AppMailRoute,
  AppPayrollRoute: AppPayrollRoute,
  AppReferenceRoute: AppReferenceRoute,
  AppRemindersRoute: AppRemindersRoute,
  AppReportsRoute: AppReportsRoute,
  AppStaffingRoute: AppStaffingRoute,
  AppTimesheetsRoute: AppTimesheetsRoute,
  AppUsersRoute: AppUsersRoute,
  AppIndexRoute: AppIndexRoute,
  AppContestsContestIdRoute: AppContestsContestIdRoute,
  AppEmployeesEmployeeIdRoute: AppEmployeesEmployeeIdRoute,
  AppMeReportsRoute: AppMeReportsRoute,
  AppMeTimesheetRoute: AppMeTimesheetRoute,
  AppProjectsProjectIdRoute: AppProjectsProjectIdRoute,
  AppCandidatesIndexRoute: AppCandidatesIndexRoute,
  AppContestsIndexRoute: AppContestsIndexRoute,
  AppEmployeesIndexRoute: AppEmployeesIndexRoute,
  AppMeIndexRoute: AppMeIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
